import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
var render = function render() {
  var _vm$previewData$dimen;
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("保费试算"),
      width: "60%",
      maskClosable: false
    },
    on: {
      cancel: _vm.closeAdd
    },
    model: {
      value: _vm.budgetVisible,
      callback: function ($$v) {
        _vm.budgetVisible = $$v;
      },
      expression: "budgetVisible"
    }
  }, [_c("h4", {
    staticStyle: {
      color: "#1890ff"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("说明：保费试算为前端投保使用，用户将根据后台配置的试算参数进行选择，以此获取对应方案的保费价格，请谨慎操作。")) + " ")]), _c("h4", {
    staticStyle: {
      color: "#d9001b"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("重要说明")) + "： " + _vm._s(_vm.$t("为避免人工失误，方案操作（编辑/复制/删除/新增）不影响保费试算时，请勿修改试算参数，按照上次默认方案进行配置")) + " ")]), _c("a-steps", {
    staticStyle: {
      width: "50%",
      margin: "30px auto"
    },
    attrs: {
      current: _vm.currentStep
    }
  }, [_c("a-step", {
    attrs: {
      title: _vm.$t("选择试算参数")
    }
  }), _c("a-step", {
    attrs: {
      title: _vm.$t("配置默认方案")
    }
  })], 1), _vm.currentStep === 0 ? _c("div", {
    staticClass: "step1"
  }, [_c("a-form-model", {
    ref: "formRef",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.rule
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("试算接口") + "：",
      prop: "type"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("保险公司接口")))]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("产品方案查询")))])], 1)], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("试算参数") + "：",
      prop: "params"
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      showSearch: "",
      "option-filter-prop": "label",
      placeholder: _vm.$t("请选择") + _vm.$t("试算参数"),
      allowClear: ""
    },
    on: {
      change: e => _vm.changeParams(e, true)
    },
    model: {
      value: _vm.form.params,
      callback: function ($$v) {
        _vm.$set(_vm.form, "params", $$v);
      },
      expression: "form.params"
    }
  }, _vm._l(_vm.paramsList, function (item) {
    return _c("a-select-option", {
      key: item.mark,
      attrs: {
        value: item.mark,
        label: item.name
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1)], 1)], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    staticStyle: {
      margin: "0 50px"
    },
    attrs: {
      size: "small",
      pagination: false,
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function (_, record) {
        return [_vm._v(_vm._s(_vm.$t(record.name)) + " ")];
      }
    }, {
      key: "field",
      fn: function (_, record) {
        return [_c("a-input", {
          staticStyle: {
            width: "90%"
          },
          attrs: {
            size: "small"
          },
          model: {
            value: record.field,
            callback: function ($$v) {
              _vm.$set(record, "field", $$v);
            },
            expression: "record.field"
          }
        })];
      }
    }, {
      key: "controls",
      fn: function (_, record) {
        var _vm$controlList;
        return [_vm._v(" " + _vm._s(_vm.$t((_vm$controlList = _vm.controlList) === null || _vm$controlList === void 0 || (_vm$controlList = _vm$controlList.find(i => i.value == record.controls)) === null || _vm$controlList === void 0 ? void 0 : _vm$controlList.name)) + " ")];
      }
    }, {
      key: "operation",
      fn: function (_, record, index) {
        return [_c("a-button", {
          attrs: {
            size: "small",
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.delBudget(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }], null, false, 2561067754)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1) : _c("div", {
    staticClass: "step2"
  }, [_c("a-spin", {
    staticStyle: {
      width: "calc(75% - 20px)"
    },
    attrs: {
      spinning: _vm.spinning
    }
  }, [_c("a-icon", {
    staticStyle: {
      "font-size": "24px"
    },
    attrs: {
      slot: "indicator",
      type: "loading",
      spin: ""
    },
    slot: "indicator"
  }), _c("a-form-model", {
    ref: "planRef",
    attrs: {
      model: _vm.planform,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.rules
    }
  }, [_vm._l(_vm.defaultData, function (item, index) {
    return _c("a-row", {
      key: item[0]
    }, [_c("a-col", {
      attrs: {
        span: 24
      }
    }, [_c("a-form-model-item", {
      attrs: {
        prop: item[0]
      }
    }, [_c("template", {
      slot: "label"
    }, [_c("a-tooltip", {
      attrs: {
        placement: "bottomLeft"
      }
    }, [_c("template", {
      slot: "title"
    }, [_c("span", [_vm._v(_vm._s(item[1].field))])]), _c("span", [_vm._v(_vm._s(item[1].field))])], 2)], 1), _c("budget-controls", {
      attrs: {
        infoBig: _vm.filterControlsValue(item[1]),
        areaCode: _vm.areaCode,
        index: index
      },
      on: {
        filter: _vm.filterConfig,
        disabledAge: _vm.disabledAge
      }
    })], 2)], 1)], 1);
  }), _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      "font-weight": "700"
    },
    attrs: {
      label: _vm.$t("保障额度"),
      prop: "amountIndex"
    }
  }, [_vm.money.length ? _c("a-radio-group", {
    on: {
      change: _vm.selectAmount
    },
    model: {
      value: _vm.planform.amountIndex,
      callback: function ($$v) {
        _vm.$set(_vm.planform, "amountIndex", $$v);
      },
      expression: "planform.amountIndex"
    }
  }, _vm._l(_vm.money, function (item, i) {
    return _c("a-radio", {
      key: i,
      attrs: {
        value: i
      }
    }, [_vm._v(_vm._s(item.amount))]);
  }), 1) : _c("span", [_vm._v("--")])], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      "font-weight": "700"
    },
    attrs: {
      label: _vm.$t("默认保费")
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.price ? _vm.price + " " + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false)) : "--"))])])], 1)], 1)], 2)], 1), (_vm$previewData$dimen = _vm.previewData.dimensions) !== null && _vm$previewData$dimen !== void 0 && _vm$previewData$dimen.length ? _c("div", {
    staticClass: "preview"
  }, [_vm._l(_vm.previewData.dimensions, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "content1"
    }, [_c("span", {
      staticClass: "left"
    }, [_c("a-tooltip", {
      attrs: {
        placement: "bottomLeft"
      }
    }, [_c("template", {
      slot: "title"
    }, [_c("span", [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.name))])]), _c("span", [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.name))])], 2)], 1), _c("span", {
      staticClass: "right"
    }, [_c("a-tooltip", {
      attrs: {
        placement: "bottomLeft"
      }
    }, [_c("template", {
      slot: "title"
    }, [_c("span", [_vm._v(_vm._s(_vm.$t(item === null || item === void 0 ? void 0 : item.value)))])]), _c("span", [_vm._v(_vm._s(_vm.replaceName.includes(item.name) ? _vm.unitReplace((item === null || item === void 0 ? void 0 : item.value) || "") : _vm.$t(item === null || item === void 0 ? void 0 : item.value)))])], 2)], 1)]);
  }), _c("div", {
    staticClass: "content1",
    staticStyle: {
      border: "none",
      "font-weight": "700",
      "font-size": "16px"
    }
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("保障额度")))]), _c("span", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.getAmount) + " " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))))])]), _c("div", {
    staticClass: "content1",
    staticStyle: {
      border: "none",
      "font-weight": "700",
      "font-size": "16px"
    }
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("保费")))]), _c("span", {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.getPrice) + " " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))))])]), _c("div", {
    staticClass: "logo"
  }, [_vm._v(_vm._s(_vm.$t("上次默认方案")))])], 2) : _vm._e()], 1), _c("template", {
    slot: "footer"
  }, [_vm.currentStep === 0 ? _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onNext
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))]) : _c("div", [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onLast
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveBudgetParams
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1)], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };